// State schema for UserSettings page

const userSettingsStateSchema = {
    title: {
        type: 'string',
        default: 'User Settings'
    },
    // Retier confirmation dialog state
    retierDialog: {
        type: 'object',
        default: {
            isOpen: false
        },
        properties: {
            isOpen: { type: 'boolean', default: false }
        }
    }
};

export default userSettingsStateSchema;
